import { AIGeneratedFieldChoice } from '@/redux/slices/formAIGenerationSlice'
import { nanoid } from '@reduxjs/toolkit'
import { BuiltFieldAttributes, FieldBuilderParams } from './baseFieldBuilder'
import { SCORABLE_CUSTOMIZED_TYPES_MAP } from './examSettingBuilder'

export default function evaluationSettingBuilder({
  scene,
  attributes,
  rawField,
}: FieldBuilderParams): Partial<BuiltFieldAttributes> | undefined {
  if (scene !== 'evaluation') return

  const choices = attributes.choices
  if (!choices || !choices.length) return

  const rawChoices: AIGeneratedFieldChoice[] = Array.isArray(rawField?.choices) ? rawField.choices : []

  const answers = choices
    .map((choice, index) => {
      if (!choice || !choice.value) return null
      const rawAtIndex = rawChoices[index]
      const score = rawAtIndex && rawAtIndex.score

      return {
        apiCode: nanoid(4),
        score: normalizeScore(score),
        correctAnswer: choice.value,
      }
    })
    .filter((a): a is NonNullable<typeof a> => !!a)

  const customizedType =
    attributes.customizedType && SCORABLE_CUSTOMIZED_TYPES_MAP[rawField.type]?.includes(attributes.customizedType)
      ? attributes.customizedType
      : SCORABLE_CUSTOMIZED_TYPES_MAP[rawField.type]?.[0]
  return {
    customizedType,
    extraConfigurableSettings: {
      type: 'AnswerBank',
      answerSettingMode: 'relative',
      answers,
      answerExplanation: undefined,
      enableAnswerExplanation: false,
    },
  } as BuiltFieldAttributes
}

function normalizeScore(score: number | null | undefined): number {
  if (typeof score === 'number' && !Number.isNaN(score)) return score
  const n = parseFloat(String(score))
  return Number.isFinite(n) ? n : 0
}
